import axios from "axios";

const authApi = axios.create({
    timeout: 15000,
    xsrfCookieName: null,
    xsrfHeaderName: null,
    headers: {
        Accept: "application/json",
    },
});

export const VerifyHuman = async (token) => {
    try {
        // console.log('$$token', token);
        const response = await authApi.post(
            "https://api-suppliers.boholgov.com/auth/verify",
            { token }
        );
        return response.data; // should return { success: true/false }
    } catch (err) {
        console.error("Human verification failed:", err);
        return { success: false };
    }
};
